// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const AirportFilledIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="AirportFilledIcon" ref={forwardedRef} {...props}>
      <path d="M11 1H9v2.5H6L6.678 5H3.75l1.518 3.865A1 1 0 0 0 6.198 9.5h1.285L6.5 18.25h7L12.51 9.5h1.302a1 1 0 0 0 .931-.637L16.25 5h-2.924L14 3.5h-3zm3 5.12-.605 1.397a1 1 0 0 1-.918.603H11v-2zm-5 0v2H7.523a1 1 0 0 1-.918-.603L6 6.12z" />
    </SvgIcon>
  );
});

/**
 * Usage only for within charts
 * @public
 */
export const AirportFilledIcon = /* @__PURE__ */ Object.assign(
  AirportFilledIconComponent,
  { displayName: 'AirportFilledIcon' },
);
